import {callApi} from '../../../../global/js/api';
import {getRelatedVariants} from '../../../../global/js/utils';
import {PICKUP_CLASS} from '../../../../global/js/constants';
import {storeNameShorter} from '../../../../global/js/findInStore';
import {optionsSelected} from './../../../pages/productDetailsPage/js/productDetailsUpdate2022';

// CONSTANTS are all caps.
const NS = 'NearbyStores';
const CLS = 'nearbyStores';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class NearbyStores {
	constructor(el) {
		// $el is the blk node return by the loadNearbyStores function
		this.$el = $(el);
		this.$toggle = this.$el.find('.nearbyStores-toggle');
		this.$list = this.$el.find('.nearbyStores-list');
		this.apiEndpoint = {
			getNearByStores: this.$el.data('get-stock-data-same-region-by-fulfilment-number-api-endpoint'),
		};
		this.dataStoreId = '';
	}

	init() {
		this.setNearbyStores();
		this.registerEvent();
	}

	registerEvent() {
		const This = this;
		this.$el.on('list.close', () => {
			this.$toggle.removeClass('active');
			this.$el.removeClass('show');
			this.$list.hide();
		});

		$('body').on('click', '.regionStorePopup-myStoreBtn', function() {
			const storeId = $(this).closest('.regionStorePopup-trow').attr('data-id');
			This.$el.attr('data-store-id', storeId);
		});
	}

	setNearbyStores() {
		this.$toggle.click(() => {
			if (this.$toggle.hasClass('active')) {
				this.$toggle.removeClass('active');
				this.$list.slideUp('slow', () => {
					this.$el.removeClass('show');
				});
			} else {
				this.$toggle.addClass('loading');
				this.dataStoreId = $(this.$el).attr('data-store-id') || '';
				this.getNearbyStores().then((res) => {
					const {
						result,
						response,
					} = res;

					if (result === 'SUCCESS') {
						const $listStore = renderNearbyStoresList(response, $(this.$el), this.dataStoreId);
						this.$list.html($listStore);
						this.$toggle.addClass('active');
						this.$list.slideDown('slow');
						this.$el.addClass('show');
					}
				}).finally(() => {
					this.$toggle.removeClass('loading');
				});
			}
		});
	}

	getNearbyStores() {
		if ($('body').hasClass('tpl-CheckoutPage')) {
			return callApi(this.apiEndpoint.getNearByStores, {
				storeId: this.dataStoreId,
			});
		} else {
			const variantCode = this.$el.attr('data-variant-code') || '';
			const quantity = this.$el.attr('data-quantity') || 1;
			const relatedVariants = getRelatedVariants();
			const productType = $('[data-pg="ProductDetailsUpdate"]').attr('data-item-type');
			let mainProduct = {};
			if (optionsSelected(productType)) {
				mainProduct = {
					code: variantCode,
					quantity: quantity,
				};
			}
			const variants = relatedVariants.concat(mainProduct);

			return callApi(this.apiEndpoint.getNearByStores, {
				fulfillmentNumber: this.dataStoreId,
				variants,
			});
		}
	}
}


export function renderNearbyStoresList(response, el, id) {
	const isPdp = el.hasClass('is-pdp');
	return response.map((store) => {
		const {
			StockData: {
				PickupStatus,
				NearByMsg,
			},
		} = store;
		const storeName = isPdp ? storeNameShorter(store.Name || '') : (store.Name || '');
		const $store = $(`<li>
			<div class='form-check'>
				<input type="radio" name="nearbyRadio" value="${store.FulfilmentNumber}" id="${store.FulfilmentNumber}"
						${store.FulfilmentNumber === id ? 'checked' : ''}>
				<label class="form-check-label" for="${store.FulfilmentNumber}" data-contentlinkid="${store.StoreId}">${storeName}</label>
			</div>
			<label class="${PICKUP_CLASS[PickupStatus] || ''} same-day-status" for="${store.FulfilmentNumber}">${NearByMsg || ''}</label>
		</li>`);

		$store.find('.form-check-label, .same-day-status').click(() => {
			$(el).trigger('choose-store', [store]);
		});

		return $store;
	});
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/nearbyStores/js/nearbyStores.js